import React from 'react';
import pseudocodeHelper from '../../../infrastructure/helpers/functions/common/pseudocodeHelper';
import locationType from '../../../types/functions/Location/LocationType';
import ReportLogicLocation from '../../../types/functions/Location/ReportLogicLocation';
import UserDefinedFunction from '../../../types/report/UserDefinedFunction';
import AssignmentBuilder from '../../Functions/Assignment/AssignmentBuilder';
import DeclarationBuilderProps from '../../Functions/Declaration/DeclarationBuilderProps';
import assignmentHelper from '../../../infrastructure/helpers/functions/assignment/assignmentHelper';

class UserDefinedFunctionBodyBuilder extends React.Component<DeclarationBuilderProps<UserDefinedFunction>> {

    constructor(props: DeclarationBuilderProps<UserDefinedFunction>) {
        super(props);

        this.onResetAssignmentClick = this.onResetAssignmentClick.bind(this);
        this.getLocation = this.getLocation.bind(this);
        this.getFunction = this.getFunction.bind(this);
        this.onReorderConditions = this.onReorderConditions.bind(this);
        this.onClearClick = this.onClearClick.bind(this);
    }

    onResetAssignmentClick(location: ReportLogicLocation): void {

        this.props.onResetAssignmentClick(location, true);
    }

    getLocation(): ReportLogicLocation {

        let location = {} as ReportLogicLocation;

        location.statement = locationType.statement.userDefinedFunction;
        location.statementNumber = this.props.declarationBatchNumber as number;

        return location;
    }

    getFunction(): UserDefinedFunction {

        return this.props.reportConfig.userDefinedFunctions.find(d => d.number === this.props.declarationBatchNumber) as UserDefinedFunction;
    }

    onReorderConditions(func: UserDefinedFunction, error?: string) {

        if (error && !func.errors.includes(error)) {
            func.errors.push(error);
        }

        let location = this.getLocation();
        this.props.onDeclarationChange(location, func);
    }

    async onClearClick(location: ReportLogicLocation, func: UserDefinedFunction, conditionNumber: number, isValue?: boolean): Promise<boolean> {

        let newFunction = assignmentHelper.clearOperandsInDeclaration(location, func, conditionNumber, isValue) as UserDefinedFunction;

        this.props.onDeclarationChange(location, newFunction);

        return Promise.resolve(false);
    }

    render(): JSX.Element {

        let location = this.getLocation();
        let func = this.getFunction();

        return (
            <>
                <AssignmentBuilder
                    reportConfigType={this.props.reportConfig.type}
                    isReadOnly={this.props.isReadOnly}
                    location={location}
                    assignment={func.assignment}
                    fieldName={pseudocodeHelper.wrapInBrackets(func.name)}
                    functions={this.props.reportConfig.userDefinedFunctions}
                    globalFunctions={this.props.collections.globalModuleConfig.userDefinedFunctions}
                    lookups={this.props.reportConfig.lookups}
                    dictionaries={this.props.reportConfig.dictionaries}
                    variables={this.props.reportConfig.variables}
                    dataSources={this.props.collections.dataSources}
                    reportFields={[]}
                    customDataSourceFields={null as any}
                    onAddAssignmentClick={this.props.onAddAssignmentClick}
                    onRemoveAssignmentClick={(location, isSingle, event, title) => this.props.onRemoveAssignmentClick(location, isSingle, event, undefined, title)}
                    onResetAssignmentClick={this.onResetAssignmentClick}
                    onLogicalOperatorChange={this.props.onLogicalOperatorChange}
                    onParenthesesChange={this.props.onParenthesesChange}
                    onAddConditionClick={this.props.onAddConditionClick}
                    onRemoveConditionClick={(location, keyword, event) => this.props.onRemoveConditionClick(location, event)}
                    onComparisonTypeChange={this.props.onComparisonTypeChange}
                    onOperandClick={this.props.onOperandClick}
                    onCopyClick={this.props.onCopyClick}
                    onPasteClick={this.props.onPasteClick}
                    onValidateFieldClick={this.props.onValidateDeclarationClick}
                    allowPaste={this.props.allowPaste}
                    onClearClick={(location: ReportLogicLocation, conditionNumber: number, isValue?: boolean) => this.onClearClick(location, func, conditionNumber, isValue)}
                    onReorderAssignmentConditions={(error) => { this.onReorderConditions(func, error); }} />
            </>
        );
    }
}

export default UserDefinedFunctionBodyBuilder;
